export type Record = {
	[key: string]: string | number | boolean;
};

export enum EDelinkUserURL {
	DELINK_USER = '/marketing/dashboard/delink/userPhone'
}
